import React from "react"
import { Typography, Grid } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import Card from "@material-ui/core/Card"
import CardContent from "@material-ui/core/CardContent"
import CardMedia from "@material-ui/core/CardMedia"

import { Container } from "@material-ui/core"
import { GatsbyImage } from "gatsby-plugin-image"

const LeistungenSectionStyle = theme => ({
  root: {
    paddingTop: theme.spacing(8),
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  grid: {
    marginTop: theme.spacing(4),
  },
  cardSection: {
    //maxWidth: "20%"
  },
})

const useStyles = makeStyles(LeistungenSectionStyle)

export default function LeistungenSection({ data }) {
  const classes = useStyles()
  return (
    <Container maxWidth="lg" className={classes.root} component="section">
      <Typography variant="h2" className={classes.title}>
        What We Do
      </Typography>
      <Typography variant="h5" color="textSecondary" component="p">
        We ask you about your goals and listen carefully to understand all your
        problems and challenges. Our experience with large and small companies
        from different industries enables us to create fast and customized
        digital solutions. We integrate your existing software, accelerate your
        digital transformation process and help you to gain much-needed
        advantages over your competitors.
      </Typography>
      <Grid container spacing={3} className={classes.grid}>
        <Grid item xs={12} sm={6} md={4}>
          <Card className={classes.cardSection}>
            {/* <CardActionArea to={'/digitale-transformation-professionelle-beratung/'}  component={Link}> */}
            <CardMedia>
              <GatsbyImage
                image={data.beratung.childImageSharp.gatsbyImageData}
                height="140"
                style={{ height: "140px" }}
                alt=""
              />
            </CardMedia>
            <CardContent>
              <Typography gutterBottom variant="h5" component="h2">
                Digital Transformation &amp; Professional Consulting
              </Typography>
              <Typography variant="body2" color="textSecondary" component="p">
                Get a second opinion or professional support in choosing your
                suppliers. Broaden the horizons of your internal digital teams.
                Reflect and optimize your processes.
              </Typography>
            </CardContent>
            {/* </CardActionArea> */}
            {/* <CardActions>
                            <Button size="small" color="primary"  to={'/digitale-transformation-professionelle-beratung/'}  component={Link}>
                                Mehr zu Beratung
                            </Button>
                        </CardActions>  */}
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Card className={classes.cardSection}>
            {/* <CardActionArea to={'/marketing-software-entwicklung/'} component={Link}> */}
            <CardMedia>
              <GatsbyImage
                image={data.software.childImageSharp.gatsbyImageData}
                height="140"
                style={{ height: "140px" }}
                alt=""
              />
            </CardMedia>
            <CardContent>
              <Typography gutterBottom variant="h5" component="h2">
                Digital marketing &amp; Agile Software Development
              </Typography>
              <Typography variant="body2" color="textSecondary" component="p">
                Build on your existing infrastructure and add simple
                transformation processes Integration of modern CRM / email
                marketing software or video conferences.
              </Typography>
            </CardContent>
            {/* </CardActionArea> */}
            {/* <CardActions>
                            <Button size="small" color="primary" to={'/marketing-software-entwicklung/'} component={Link}>
                                Mehr zu Softwareentwicklung
                            </Button>
                        </CardActions>  */}
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Card className={classes.cardSection}>
            {/* <CardActionArea to={'/technologiestudien-prototypentwicklung/'} component={Link}> */}
            <CardMedia>
              <GatsbyImage
                image={data.labor.childImageSharp.gatsbyImageData}
                height="140"
                style={{ height: "140px" }}
                alt=""
              />
            </CardMedia>
            <CardContent>
              <Typography gutterBottom variant="h5" component="h2">
                Technology studies &amp; prototype development
              </Typography>
              <Typography variant="body2" color="textSecondary" component="p">
                Risk assessments of new technologies (blockchain, machine
                learning, cloud infrastructure, voice interface, mobile
                applications, ...) in relation to your company or startup.
                Creation of prototypes to test market acceptance.
              </Typography>
            </CardContent>
            {/* </CardActionArea> */}
            {/* <CardActions>
                            <Button size="small" color="primary" to={'/technologiestudien-prototypentwicklung/'} component={Link}>
                                Mehr zu Technologiestudien
                            </Button>
                        </CardActions>  */}
          </Card>
        </Grid>
      </Grid>
    </Container>
  )
}
